module.exports = __webpack_public_path__ + "fonts/OpenSans-LightItalic.6943fb6f.ttf";